export const setPagination = ({
  onChange,
  pageNumber,
  pageSize,
  section,
  target,
}): Function => state => {
  if (target) {
    const pageIsValid = target.checkValidity();

    if (pageIsValid === false) {
      window.setTimeout(() => target.form.reportValidity(), 100);

      return false;
    }
  }

  const pagination: any = { pageNumberInvalid: false };

  if (pageSize !== undefined) {
    pagination.pageSize = Number(pageSize);
  } else {
    pagination.pageSize = state[section].pagination.pageSize;
  }

  pagination.pageCount = Math.ceil(
    state[section].pagination.itemCount / pagination.pageSize,
  );

  if (pageNumber !== undefined) {
    pagination.pageNumber = Number(pageNumber);

    if (
      pagination.pageNumber >
      Math.ceil(state[section].pagination.itemCount / pagination.pageSize)
    ) {
      pagination.pageNumber = Math.ceil(
        state[section].pagination.itemCount / pagination.pageSize,
      );
    }

    if (pagination.pageNumber < 1 || state[section].pagination.itemCount <= 0) {
      pagination.pageNumber = 1;
    }

    if (
      pagination.pageNumber !== state[section].pagination.currentPageNumber ||
      pagination.pageSize !== state[section].pagination.currentPageSize
    ) {
      Promise.resolve().then(onChange);
    }
  }

  return {
    ...state,
    [section]: {
      ...state[section],
      pagination: {
        ...state[section].pagination,
        ...pagination,
      },
    },
  };
};
